import { HStack, Text, Box, Tooltip } from "@chakra-ui/react";
import React, { useState } from "react";
import TableStyle from "../../Components/Common/TableStyle";
import { Pagination, Search } from "../../Components/Common/UI";
import TableV6 from "../../Components/Common/TableV6";
import Api from "../../Helper/ApiHandler";
import { useQuery } from "react-query";
import { useDebounce } from "../../Helper/Hooks/useDebounce";
import { useLocation } from "react-router-dom";

const ContactUsTable = () => {
  const { state } = useLocation();
  const api = new Api();
  const [search, setSearch] = useState("");
  const [params, setParams] = useState({
    pageNo: 1,
    pageSize: 25,
    order: "DESC",
    sortBy: "id",
  });
  const [data, setData] = useState([]);

  const debouncedSearchTerm = useDebounce(search, 1000);

  const fetchContactUsData = async ({ queryKey }) => {
    const ContactUsList = await api.post(`${"contact-us/list"}`, {
      page: state?.count ? state.pageNo : queryKey[2].pageNo,
      search: state?.count ? state.search : queryKey[1],
      order: state?.count ? state.order : queryKey[2].order,
      sortBy: state?.count ? state.sortBy : queryKey[2].sortBy,
    });
    setData(ContactUsList?.data?.rows);
    return ContactUsList;
  };

  const { isLoading, data: userData } = useQuery(
    ["contactUsLists", debouncedSearchTerm, params],
    fetchContactUsData
  );

  const handlePageChange = (page) => {
    setParams((prev) => ({ ...prev, pageNo: page.selected + 1 }));
  };

  const handleSortBy = (sortBy) => {
    setParams((prev) => ({
      ...prev,
      sortBy: sortBy[0]?.id || "id",
      order: sortBy[0]?.desc ? "DESC" : "ASC",
    }));
  };

  const columns = [
    {
      Header: () => (
        <Box>
          <Text marginLeft={"5px"}>Full Name</Text>
        </Box>
      ),
      accessor: "fullname",
      Cell: (row) => <Text textAlign={"center"}>{row.original.fullname}</Text>,
      sortable: false,
    },
    {
      Header: () => (
        <Box>
          <Text marginLeft={"5px"}>Email</Text>
        </Box>
      ),
      accessor: "email",
      Cell: (row) => (
        <Text textAlign={"center"} textTransform={"lowercase"}>
          {row.value}
        </Text>
      ),
    },
    {
      Header: () => (
        <Box>
          <Tooltip label="This is the message column" placement="top" hasArrow>
            <Text marginLeft={"5px"}>Message</Text>
          </Tooltip>
        </Box>
      ),
      accessor: "message",
      Cell: (row) => (
        <Tooltip label={row.original.message} placement="top" hasArrow>
          <Text textAlign={"center"} isTruncated>
            {row.original.message}
          </Text>
        </Tooltip>
      ),
      sortable: false,
    },
  ];

  return (
    <>
      <HStack
        display={"flex"}
        justifyContent={"space-between"}
        paddingBottom={"10px"}
      >
        <Search
          search={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setParams({ ...params, pageNo: 1 });
          }}
          resetSearch={() => setSearch("")}
        />
      </HStack>
      <TableStyle version={6}>
        <TableV6
          columns={columns}
          data={data}
          handleSortBy={handleSortBy}
          isLoading={isLoading}
          key={"master-rep-table"}
        />
        {data.length ? (
          <Pagination
            key={"ContactUsPagination"}
            handlePageChange={handlePageChange}
            pageSize={10}
            total={userData?.data?.count || 0}
            currentPage={params.pageNo}
          />
        ) : null}
      </TableStyle>
    </>
  );
};

export default ContactUsTable;
